import { render, staticRenderFns } from "./MaxPriceAdjustmentOverview.vue?vue&type=template&id=5d645106&"
import script from "./MaxPriceAdjustmentOverview.vue?vue&type=script&lang=js&"
export * from "./MaxPriceAdjustmentOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports